import { ref, watchEffect } from 'vue'
import { api } from '@/helpers/api'
import { useGoogleAPI } from '@/composables/utils/useGoogleAPI'
import { useValidation } from '@/composables/utils/useValidation'

import useNotification from '@/composables/useNotification.js'

const autocomplete = ref(null)

const URLS = {
    xhr: {
        mutate: {
            create: '/api/profile/v1/info/artist/create',
            update: '/api/profile/v1/info/artist',
            social: '/api/profile/social/link/add-artist'
        }
    }
}
export const useDirectBookingArtistUpdate = (userData, newArtist, load) => {
    const { isValid } = useValidation()
    const { notification } = useNotification()
    const { apiLoaded, initialize, lat, lng, fullAddress, placesTriggered } = useGoogleAPI()

    watchEffect(() => {
        const googleRef = autocomplete.value

        if (apiLoaded.value && ref) {
            initialize({
                mode: 'autocomplete',
                templateRef: googleRef,
                types: ['(cities)']
            })
        }
    })
    watchEffect(() => {
        if (placesTriggered.value) {
            const { address } = _formatGoogleAddress(fullAddress.value)
            userData.value.artistInfo.home_location = address
            userData.value.artistInfo.lat = lat
            userData.value.artistInfo.lon = lng
        }
    })

    function _formatGoogleAddress(address) {
        if (!address) return
        const addressArr = address.split(', ')

        const city = addressArr[0]
        const stateZip = addressArr[1]
        const state = stateZip.split(' ')[0]

        const fullAddress = city + ', ' + state

        return { address: fullAddress, city }
    }
    async function updateArtist(v, data) {
        if (isValid(v)) {
            try {
                load.value = true
                const response = await api({
                    method: 'post',
                    url: newArtist.value
                        ? `${URLS.xhr.mutate.create}/${userData.value.id}`
                        : `${URLS.xhr.mutate.update}/${userData.value.artistInfo.id}`,
                    data: {
                        _method: 'PUT',
                        ...data,
                        ...userData.value.artistInfo
                    }
                })

                if (!userData.value.artistInfo.id && response.data.id) {
                    userData.value.artistInfo.id = response.data.id
                }
                if (!userData.value.socialInfo.slug && response.data.slug) {
                    userData.value.socialInfo.slug = response.data.slug
                }
                return true
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Update Artist failed.')
            return false
        }
    }

    async function updateSocials(v, id) {
        if (isValid(v)) {
            if (userData.value.socialInfo.web_site || userData.value.socialInfo.slug) {
                await updateArtist(v, userData.value.socialInfo)
            }

            try {
                load.value = true
                await api({
                    method: 'put',
                    url: `${URLS.xhr.mutate.social}/${id}`,
                    data: userData.value.socials
                })
                return true
            } catch {
                return false
            } finally {
                load.value = false
            }
        } else {
            notification('error', 'Update Social failed.')
            return false
        }
    }

    return {
        updateArtist,
        updateSocials,
        autocomplete
    }
}
